<template>
  <div id="discover">
    <AppNavSub :routes="discoverRoutesWithGenresState"/>
    <router-view/>
  </div>
</template>

<script>
import AppNavSub from "@/components/header/AppNavSub";
import configRoutes from "@/router/configRoutes";
import {mapState} from "vuex";

export default {
  name: "Discover",
  components: {
    AppNavSub
  },
  data: () => ({
    discoverRoutes: configRoutes.appNavSubRoutes.discover
  }),
  computed: {
    ...mapState({
      genresState: state => state.genresState,
      discoverRoutesWithGenresState(state) {
        return this.discoverRoutes.map(route => {
          route.enabled = state.genresState;
          return route;
        });
      }
    })
  },
}
</script>

<style scoped>

</style>
